import React from 'react';
import './CornerRibbon.css';

interface CornerRibbonProps {
  position?: 'top-right' | 'top-left' | 'bottom-left' | 'bottom-right';
}
const CornerRibbon: React.FC<CornerRibbonProps> = ({
  position = 'top-right',
  children,
}) => {
  let positionClass = 'TR';
  switch (position) {
    case 'bottom-left':
      positionClass = 'BL';
      break;
    case 'bottom-right':
      positionClass = 'BR';
      break;
    case 'top-left':
      positionClass = 'TL';
      break;
    case 'top-right':
    default:
      // no change to default value
      break;
  }
  return (
    <div className={['CornerContainer', positionClass].join(' ')}>
      <div className={['CornerRibbon', positionClass].join(' ')}>
        {children}
      </div>
    </div>
  );
};

export default CornerRibbon;
